module.exports = __webpack_public_path__ + "static/img/intro-cont03.64f06aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_b2c/intro-cont03.jpg
// module id = oZLX
// module chunks = 0